import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField, Box, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import dayjs, { Dayjs } from 'dayjs';

interface CommonTimePickerProps {
    label: string | any;
    value: string | null;
    onChange: (newTime: string | null) => void;
    error?: boolean;
    helperText?: React.ReactNode;
    disabled?: boolean;
}

// function parseTimeValue(value: string | null): Dayjs | null {
//     if (!value) return null;
//     const formats = [
//         'h A',    // 9 AM
//         'ha',     // 9am
//         'hA',     // 9AM
//         'h a',    // 9 am
//         'h:mm A', // 9:00 AM
//         'h:mma',  // 9:00am
//         'hh:mm A',
//         'hh:mmA'
//     ];
//     const parsed = dayjs(value.trim(), formats, true);
//     return parsed.isValid() ? parsed : null;
// }
function parseTimeValue(value: string | null): Dayjs | null {
    if (!value || typeof value !== 'string') return null; // ✅ Prevents .trim() crash
    const formats = [
        'h A', 'ha', 'hA', 'h a', 'h:mm A', 'h:mma', 'hh:mm A', 'hh:mmA'
    ];
    const parsed = dayjs(value.trim(), formats, true);
    return parsed.isValid() ? parsed : null;
}
export default function CommonTimePicker({
    label = "Select Time",
    value = null,
    onChange,
    error = false,
    helperText = '',
    disabled = false,
}: CommonTimePickerProps) {
    // const parsedValue: Dayjs | null = parseTimeValue(value);
    const parsedValue: Dayjs | null = parseTimeValue(typeof value === 'string' ? value : null);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                label={label}
                value={parsedValue}
                onChange={newVal => {
                    if (newVal) {
                        onChange(newVal.format('hh:mm A'));
                    } else {
                        onChange(null);
                    }
                }}
                size="small"
                slotProps={{
                    textField: {
                        size: 'small',
                        fullWidth: true,
                    },

                }}
                disabled={disabled}   // 👈 disable picker
                renderInput={params => (
                    <TextField
                        {...params}
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        error={error}
                        helperText={helperText}
                        disabled={disabled}
                    />
                )}
            />
        </LocalizationProvider>
    );
}
